import React, { useState, useEffect } from 'react';
import { useStore } from '../../context/store';

export default function FilterTrueFalse( props ) {
    const {
        state,
        dispatch,
    } = useStore();

    const toggleFilter = ( event, field, value ) => {
        if ( event.target.checked && null != value ) {
            dispatch({ 
                type: 'setFilter', 
                payload: { 
                    'field': field, 
                    'value': value,
                } 
            })
        } else {
            dispatch({ 
                type: 'removeFilter', 
                payload: field 
            })
        }
    }

    const pre = 'ygl-filter-true-false';

    if ( 'undefined' !== typeof props.filter && state !== typeof 'undefined' ) {
        const filter = props.filter;

        return (
            <div className={`ygl-filter ${pre}`}>
                {filter.options.map( (option, index) => {
                    const isChecked = 'undefined' !== typeof state.filters[ option.field ] 
                        ? state.filters[ option.field ] == option.value
                        : null === option.value;

                    return (
                        <div className={ `${pre}__option` } key={ index }>
                            <label htmlFor={ `${option.field}-${index}` } className={ `${pre}__label` }>
                                <input 
                                        id={ `${option.field}-${index}` } 
                                        type="checkbox" 
                                        className="sr-only" 
                                        name={ option.value } 
                                        onChange={ e => toggleFilter( e, option.field, option.value ) }
                                        checked={ isChecked }
                                    />
                                    <div className={ `${pre}__option-title` }>{ option.name }</div>
                            </label>
                        </div>
                    )
                })}
            </div>
        )
    }

    return '';
}